<template>
    <div class="scroll-arrow-menu">
        <div class="scroll-arrow-menu-arrow scroll-arrow-menu-arrow-left" :class="bgColorArrows" v-on:click.stop="slideLeft()" v-if="showLeftArrow()">
            <button class="btn btn-link">
                <font-awesome-icon icon="fa-solid fa-angle-left"/>
            </button>
        </div>
        <DivToVueComponent class="scroll-arrow-menu-body" ref="scrollArrowMenuBody" :style="cssHackedDiv()">
            <div class="scroll-arrow-menu-buttons" :style="'width:'+buttonsHackWidth+'px'">
                <button v-for="menu in data"
                        :key="keyMenuTag(menu.name)"
                        :id="keyMenuTag(menu.name)"
                        v-on:click.stop="menuClicked(menu.name)"
                        class="btn btn-link btn-menu btn-scroll-arrow-menu"
                        :class="fontWeight + ' ' + (open === menu.name? 'active font-extra-bold' : '')"
                >
                    {{translate(translationType, menu.name, language)}}
                    <span class="badge badge-primary">{{menu.value}}</span></button>
            </div>
        </DivToVueComponent>
        <div class="scroll-arrow-menu-arrow scroll-arrow-menu-arrow-right" :class="bgColorArrows" v-on:click.stop="slideRight()" v-if="showRightArrow()">
            <button class="btn btn-link">
                <font-awesome-icon icon="fa-solid fa-angle-right"/>
            </button>
        </div>
    </div>
</template>

<script>
import DivToVueComponent from "./DivToVueComponent";
import { mapGetters } from 'vuex'
const _ = require('lodash')
    export default {
        name: 'ScrollArrowMenu',
        components: {DivToVueComponent},
        props: {
            data: Object,
            open: String,
            translationType: String,
            fontWeight: String,
            bgColorArrows: {
                type: String,
                default: 'bg-transparent'
            }
        },
        data() {
          return {
              buttonsHackWidth: 1500,
              countClickRight:0,
              maxRightReached : false,
          }
        },
        watch: {
          isOverflowing() {
                if(!this.isOverflowing && this.countClickRight > 0){
                    this.countClickRight = 0
                    this.maxRightReached = false
                }
            }
        },
        computed: {
            ...mapGetters({
                windowWidth: 'settings/windowWidth',
                language: 'settings/language',
            }),
            isOverflowing() {
                return  this.windowWidth < this.buttonsHackWidth
            }
        },
        methods:{
            menuClicked(key) {
                this.$emit('menuClicked',key)
            },
            slideLeft() {
                this.sideScroll('left');
            },
            slideRight() {
                this.sideScroll('right');
            },
            sideScroll(direction) {
                let step = 10;
                let scrollAmount = 0;
                let element = this.$refs.scrollArrowMenuBody.$el
                let slideTimer = setInterval(() => {
                    if(direction === 'left'){
                        this.countClickRight--
                        this.maxRightReached = false
                        element.scrollLeft -= step;
                    } else {
                        let previousScrollLeft = element.scrollLeft
                        element.scrollLeft += step;
                        if(previousScrollLeft !== element.scrollLeft){
                            this.countClickRight++
                        }
                        else{
                            this.maxRightReached = true
                        }
                    }
                    scrollAmount += step;
                    if(scrollAmount >= 100){
                        window.clearInterval(slideTimer);
                    }
                }, 25);
            },
            keyMenuTag(key) {
                return 'key_menu_'+key
            },
            showLeftArrow() {
                return this.isOverflowing && this.countClickRight > 0
            },
            showRightArrow(){
              return this.isOverflowing && !this.maxRightReached
            },
            cssHackedDiv() {
                let css = ""
                if(this.showLeftArrow()){
                    css = "left:34px; width:" + (this.windowWidth - 34) + "px"
                }
                else{
                    css = "width: 100%"
                }
                return css
            }
        },
        updated() {
            let buttonsHackWidth = 23 //because of the paddings
            _.forEach(this.data, (menu) => {
                let tagName = this.keyMenuTag(menu.name)
                buttonsHackWidth += this.$el.querySelector('#'+tagName).offsetWidth
            })
            this.buttonsHackWidth = buttonsHackWidth
        }
    }
</script>